import { lockScroll, unlockScroll } from '../utils/util-functions';
import { fetchAllManuals, performSearch } from '../utils/searchFiles';

export default (node) => {
  const searchInput = node.querySelector('[data-search-input]');
  const closeButton = node.querySelector('[data-close-search]');
  const trendingSection = node.querySelector('#trending-products');
  const resultsSection = node.querySelector('[data-search-results]');
  const productsTab = node.querySelector('[data-tab="product"]');
  const pagesTab = node.querySelector('[data-tab="page"]');
  const assemblyTab = node.querySelector('[data-tab="assembly"]');
  const resultsContainer = node.querySelector('[data-results-container]');
  const overlayContainer = node.querySelector('[data-search-overlay');
  const noResultsText = node.getAttribute('data-no-results-text');
  const overlay = node.querySelector('[data-search-overlay]');
  const searchForm = node.querySelector('[data-form-search]');
  const storefrontUrl = node.dataset.storefrontUrl;
  const accessToken = node.dataset.accessToken;
  const language = node.dataset.language === 'en' ? '' : '/fr';
  const searchUrl = node.dataset.searchUrl || `${language}/search`;
  const languageToSearch = node.dataset.language;
  const imageDefault = node.dataset.imageDefault;
  let allManuals = [];

  // Set aria-live for accessibility
  resultsContainer.setAttribute('aria-live', 'polite');

  let searchType = 'product';
  let searchDebounceTimer = null;

  const toggleSearchVisibility = () => {
    node.classList.toggle('hidden');

    // Add or remove outside click listener based on the visibility
    if (!node.classList.contains('hidden')) {
      document.addEventListener('mousedown', handleOutsideClick);
      searchInput.focus();
      lockScroll();
      document.dispatchEvent(new CustomEvent('desktop-menu:close'));
    } else {
      document.removeEventListener('mousedown', handleOutsideClick);
      unlockScroll();
    }
  };

  const handleOutsideClick = (event) => {
    // Check if the click is outside the overlay container
    if (!overlayContainer.contains(event.target)) {
      // toggleSearchVisibility();
    }
  };

  // Event handlers with a debounce
  const handleSearchInput = () => {
    setSearchType('product');

    // Clear any existing debounce timer
    if (searchDebounceTimer) {
      clearTimeout(searchDebounceTimer);
    }

    if (searchInput.value) {
      trendingSection.classList.add('hidden');
      resultsSection.classList.remove('hidden');

      // Debounce the searchContent call (300ms delay)
      searchDebounceTimer = setTimeout(() => {
        searchContent(searchInput.value);
        searchDebounceTimer = null;
      }, 300);
    } else {
      trendingSection.classList.remove('hidden');
      resultsSection.classList.add('hidden');
    }
  };

  const setSearchType = async (type) => {
    searchType = type;

    // Reset both tabs: remove underline and primary text color, add secondary text color
    productsTab.classList.remove('tab-current');
    pagesTab.classList.remove('tab-current');
    assemblyTab.classList.remove('tab-current');

    // Apply active styles to the selected tab
    switch (type) {
      case 'product':
        productsTab.classList.add('tab-current');
        resultsContainer.classList.remove('pages-results');
        break;
      case 'page':
        pagesTab.classList.add('tab-current');
        resultsContainer.classList.add('pages-results');
        break;
      case 'assembly':
        assemblyTab.classList.add('tab-current');
        resultsContainer.classList.remove('pages-results');
        break;
    }

    if (type === 'assembly') {
      resultsContainer.innerHTML = '';
      const filesResults = await performSearch(
        allManuals,
        searchInput.value,
        storefrontUrl,
        accessToken
      );
      filesResults.innerHTML = filesResults.innerHTML.replace(
        'no-results',
        noResultsText
      );
      resultsContainer.innerHTML = filesResults.innerHTML;
    } else {
      if (searchInput.value) {
        searchContent(searchInput.value);
      }
    }
  };

  const searchContent = (query) => {
    resultsContainer.innerHTML = '';

    const resourceType = searchType === 'product' ? 'KLEVU_PRODUCT' : 'KLEVU_CMS';

    const url = languageToSearch === 'en' ? 'https://uscs34v2.ksearchnet.com/cs/v2/search' : 'https://uscs35v2.ksearchnet.com/cs/v2/search';

    const apiKey = languageToSearch === 'en' ? 'klevu-174654482218016753' : 'klevu-175709894654316753';

    // generate a random complext id
    const id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    fetch(
      url,
      {
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify({
          "recordQueries": [
            {
              "id": id,
              "typeOfRequest": "SEARCH",
              "settings": {
                "query": {
                  "term": query
                },
                "limit": 10,
                "typeOfRecords": [resourceType]
              }
            }
          ],
          "context": {
            "apiKeys": [apiKey]
          }
        }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        let results = null;
        if (searchType === 'product') {
          results = data.queryResults.find(result => result.id === 'productList')
          if (results) {
            results = results.records;
          } else {
            results = data.queryResults && data.queryResults.length > 0 && data.queryResults[0].records && data.queryResults[0].records.length > 0 ? data.queryResults[0].records : null;
          }
        } else {
          results = data.queryResults.find(result => result.id === 'cmsCompressed')
          if (results) {
            results = results.records;
          } else {
            results = data.queryResults && data.queryResults.length > 0 && data.queryResults[0].records && data.queryResults[0].records.length > 0 ? data.queryResults[0].records : null;
          }
        }
          if (results && results.length > 0) {
          resultsContainer.innerHTML = '';
          results.forEach((item, index) => {
            const itemHTML = `
              <a class="product-item" href="${item.url}">
                <img src="${item.image ? item.image : imageDefault}" alt="${item.name}" class="product-image" style="${item.image ? '' : 'object-fit: contain;'}">
                <div class="product-text">
                <p class="text-xs-medium text-gray-60">${searchType === 'product' ? item.Collection : item.type}</p>
                <p class="text-lg-medium line-clamp-1">${item.name}</p>
                </div>
              </a>`;
            resultsContainer.insertAdjacentHTML('beforeend', itemHTML);
          });
        } else {
          resultsContainer.innerHTML = `<p class="text-center mt-4 md:col-span-5 w-full">${noResultsText}</p>`;
        }
      });
  };

  // Event listeners
  searchInput.addEventListener('input', handleSearchInput);
  closeButton.addEventListener('click', toggleSearchVisibility);
  productsTab.addEventListener('click', () => setSearchType('product'));
  pagesTab.addEventListener('click', () => setSearchType('page'));
  assemblyTab.addEventListener('click', () => setSearchType('assembly'));
  overlay.addEventListener('click', toggleSearchVisibility);
  document.addEventListener('search:open', toggleSearchVisibility);

  const goToSearchPage = () => {
    window.location.href = `${searchUrl}?q=${encodeURIComponent(searchInput.value)}`;
  };

  searchForm.addEventListener('submit', (e) => {
    e.preventDefault();
    goToSearchPage();
  });

  // Search apps (e.g. Klevu) bind Enter on input[name=q] and redirect to their own,
  // sometimes translated, landing URL (/fr/recherche 404s). Handle Enter first, in the
  // capture phase, so the theme's search URL always wins.
  ['keydown', 'keypress', 'keyup'].forEach((type) => {
    window.addEventListener(type, (e) => {
      if (e.target !== searchInput || e.key !== 'Enter') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (type === 'keydown') goToSearchPage();
    }, true);
  });

  // Initial state
  handleSearchInput();

  const handleAssemblyFilesResults = async (e) => {
    const assemblyFilesResults = e.detail.node;

    const searchTerm = e.detail.searchTerm;

    const filesResults = await performSearch(
      allManuals,
      searchTerm,
      storefrontUrl,
      accessToken
    );
    filesResults.innerHTML = filesResults.innerHTML.replace(
      'no-results',
      noResultsText
    );
    assemblyFilesResults.innerHTML = filesResults.innerHTML;
    // update the count of results
    const countResults = assemblyFilesResults.querySelector(
      '[data-count-results]'
    );
    const assemblyTab = document.querySelector(
      '[data-section="assemblyFiles"] > b'
    );
    if (countResults && assemblyTab) {
      assemblyTab.textContent = countResults.dataset.countResults;
      assemblyTab.style.display = 'unset';
    }
  };

  // Fetch all manuals
  const init = async () => {
    allManuals = await fetchAllManuals(storefrontUrl, accessToken);

    // call assembly files results from Klevu app
    document.addEventListener(
      'search-files:get-assembly-files',
      handleAssemblyFilesResults
    );
  };

  init();
};
